import styled from 'styled-components';
export function vw (pxValue) {
    return pxValue * 1 + 'rem'
  }
// import ButtonBg from '../../assets/imgs/svg/btn_bg.svg';
import ButtonBg from '../../assets/imgs/svg/add-btn-bg.svg';
import BackBg from '../../assets/imgs/svg/back_jump.svg';
import BackBgHover from '../../assets/imgs/svg/back_jump_hover.svg';


export const MainContainer = styled.div`
  width:${vw(848)};
  background-color: #EFF6FA;
  padding:32px;
  border-radius:16px;
  position: absolute;
  left:50%;
  top:${vw(168)};
  transform:translate(-50%,0);
`;

export const BackButton = styled.div`
    position: absolute;
    left:0;
    top:${vw(-64)};
    width:40px;
    height:40px;
    background-image: url(${BackBg});
    cursor: pointer;
    &:hover{
      background-image: url(${BackBgHover});
    }
`;

export const MainContent = styled.div`
  background-color: #fff;
  border-radius:8px;
  padding:24px;
`;

export const StyledButton = styled.button`
  position: relative;
  display: block;
  width: 350px;
  height: 61px;
  line-height: 40px;
  border-radius: ${vw(8)};
  text-align: center;
  background-image: url(${ButtonBg});
  outline: none;
  border: none;
  font-weight: 700;
  font-size: ${vw(24)};
  text-align: center;
  color: #FFFFFF;
  margin: ${vw(40)} auto 0;
  cursor: pointer;

  &[disabled] {
    color: #fff !important;
    background: #C4C4C4 !important;
  }

`;

export const LoadText = styled.div`
  text-align: center;
  font-size: ${vw(16)};
  padding-top: ${vw(60)};
`;
